import { redirect } from '@tanstack/react-router';
import type { FeatureFlagType } from '../model/featureFlag';
import { getFeatureFlagStatus } from '../model/useFeatureFlag';

/**
 * beforeLoad でのみ使用する。機能フラグ（テナント単位）をチェックし、
 * `visible` 以外（`disabled` / `hidden`）なら 404 ページへリダイレクトする。
 *
 * `disabled` はメニュー上「非活性（遷移不可）」の扱いのため、URL 直アクセスも遮断する。
 * メニューからの除外（`hidden`）だけでは URL 直打ちでページが見えてしまうのを防ぐ。
 */
export const requireFeatureFlag = (featureFlagType: FeatureFlagType) => {
  if (getFeatureFlagStatus(featureFlagType) !== 'visible') {
    throw redirect({ to: '/404' });
  }
};
